import React, { useState } from "react";
import { TENANTS } from "../../consts/tables";
import CRUD from "../CRUD/CRUD";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";
import { ApolloConsumer } from "@apollo/client";
import { GET_TENANTS, GET_TENANT_BY_ID } from "../Graphql/Queries/TenantQuery";
import { CREATE_TENANTS } from "../Graphql/Mutations/TenantMutation";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_UPDATE_CONTACTS_TENANTS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_CONTACT_TENANTS_BY_ID, GET_CONTACT_TENANTS_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import TenantInfo from "../CRUDTenant/TenantInfo";
import UserInfo from "./UserInfo";
import userStatusCode from "../../userStatusCode";
import { GET_USER_BY_EMAIL_ID } from "../Graphql/UserQueries/userquaries";
import { CREATE_USER } from "../Graphql/UserQueries/UserMutation";

export default class CRUDUser extends React.Component { 
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      searchCrudFilter : false,
      filterData: [],
      currentIndex: 0,
      fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
      isExists: false,
      typeDuplicate:null
    };
    this.client = null;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.saveData = this.saveData.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.updateURL = this.updateURL.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    if (this.state.fromListUrl) {
      localStorage.setItem('fromListUrl', this.state.fromListUrl);
      this.setState({ fromListUrl: this.state.fromListUrl });
    }
    const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
    if(!hasQuery){
      this.fetch(this.props.params.id);
    }
    if(hasQuery){
      this.setState({ searchCrudFilter: true });
      this.handleQueryChange();
    }
  }

  parseFilterOptions(query){
    const filterObject = {};
    if(query){
        for(const key in query){
            if(key !== 'order' && key !== 'page'){
                filterObject[key]= query[key]
            }
        }
    }
    return [filterObject]
}

 componentDidUpdate(prevProps) {
    const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
    const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
    if (hasQuery && prevProps.location.search !== this.props.location.search) {
      this.handleQueryChange();
      this.setState({ searchCrudFilter: true });
    }

    if(!hasQuery && prevHasQuery){
      this.fetch(this.props.params.id);
      this.setState({ searchCrudFilter: false });
    }
  }

  handleQueryChange() {
    const query = this.props.location.query;
    const filterOptions = this.parseFilterOptions(query); 
  
    var isNoFilter = Object.keys(filterOptions).length === 0; 
  
    if (isNoFilter) {
      this.fetch(this.props.params.id);
    }
    else{
      this.fetchWithFilter(filterOptions)
    }
  }

fetchWithFilter(filterOptions) {
  this.setState({
    data: null,
    error: null,
    success: null,
  });

  fetchData(GET_CONTACT_TENANTS_LIST_QUERY, { type:"Tenant",filters:filterOptions})
        .then(res => {
          const filterData = res.data.getContacts.data|| [];
          if(filterData.length > 0){
            this.setState({
              // items: res.data.getCompanies.data,
              // totalCount: res.data.getCompanies.totalCount,
              // error: null,
              // isBusy: null,
              filterData,
              currentIndex:0,
              data:  filterData[0],
              original: { ...filterData[0] },
              error: null,
            },() => {
              this.updateURL(filterData[0]);
            });
          }else {
            this.setState({
              filterData: [],
              data: false,
              error: "No filtered data found. Please try again with different filters.",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
    
}



updateURL(data) {
    const queryParams = new URLSearchParams(this.props.location.search);
    // const name = queryParams.get("name");
    // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
    const newUrl = `/Tenant/${data.contact_id}?${queryParams.toString()}`;
    browserHistory.push(newUrl);
  }

  fetch(id) {
    this.setState({
    // data: null, we have comment this line to avoid loading symbol has ali dont want to be screen get change when value is null we was showing loader 
      error: null,
      success: null,
    });

    if (id === undefined) {
      this.setState({
        data: { status_code : "Active" },
      });
      return;
    }
    const token = localStorage.getItem('authToken');

    // this.client
    //     .query({
    //       query: GET_TENANT_BY_ID,
    //       variables: { arcimedes_row_id: id },
    //       fetchPolicy: "no-cache",
    //       context: {
    //         headers: {
    //           authorization: `Bearer ${token}`,
    //         },
    //       },
    //     })
    // fetchData(GET_TENANT_BY_ID, { arcimedes_row_id: id })
    // .then((res) => {
    //   if (res && res.data && res.data.getTenent) {
    //     this.setState({
    //       data: res.data.getTenent,
    //       original: { ...res.data.getTenent },
    //       error: null,
    //     });
    fetchData(GET_USER_BY_EMAIL_ID, { getUserId: id })
        .then((res) => {
          if (res && res.data && res.data.getUser) {
            this.setState({
              data: res.data.getUser,
              original: { ...res.data.getUser},
              error: null,
            });
          } else {
            this.setState({
              data: false,
              error: res.errors ? res.errors[0].message : "Unidentified Error",
            });
          }
        })
        .catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
  }

  handleSubmit(client, e) {
    e.preventDefault();
    this.setState({
      isExists:false,
      typeDuplicate:null
    });
    if (this.state.viewMode) this.setState({ viewMode: false });

    if (
      this.state.isBusy ||
      (this.state.data.first_name  === "" || this.state.data.last_name  === "") ||
      this.state.viewMode === true
    )
      return;

    this.setState({ viewMode: true }, () => this.saveData(client));
  }

  handleChangeInput(key, value) {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [key]: value
      }
    }));
  }
  
  handleChangeDropdown(query, queryType, x, key) {
    const userContactTypes = key === "contact_type" && query.contact_type.split(',').map(type => type.trim());

    if (key === "contact_type" && (userContactTypes.length > 1 || query.contact_type === "Tenant") && this.state.typeDuplicate) {
      const match = this.state.typeDuplicate.match(/for\s(.+?)\stype/i); // extract "Agent, Investor, Lender"
      const messageContactTypes = match ? match[1].split(',').map(type => type.trim()) : [];

      const hasMatch = userContactTypes.some(type => messageContactTypes.includes(type));
      if (!hasMatch) {
        this.setState({
          isExists: false,
          typeDuplicate: null,
          isBusy: false,
        });
      }
    }
    this.setState({
        data: Object.assign(this.state.data, {
            [key]: query[key],
        }),
    });
}

 async saveData(client) {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });
const isDeleted = this.state.data.deleted === 1;
const status_code = isDeleted ? "Inactive" : this.state.data.status_code || null;

const input = {
  id: this.props.params.id ? this.props.params.id : "",
  // first_name:this.state.data.first_name ? this.state.data.first_name : null,
  // middle_name:this.state.data.middle_name? this.state.data.middle_name : null,
  // last_name:this.state.data.last_name ? this.state.data.last_name : null,
  username : this.state.data.username ? this.state.data.username : null,
  email: this.state.data.email ? this.state.data.email : null,
  password_hash:this.state.data.password ? this.state.data.password : null,
  user_type:this.state.data.user_type ? this.state.data.user_type : null ,
  type_code:this.state.data.type_code ? this.state.data.type_code : null ,
  status_code : status_code,
  //})
};

    try {
      const res = await mutateData(CREATE_USER, {
        input:input
        },)
      if (res && res.data && res.data.createOrUpdateUser && res.data.createOrUpdateUser.success) {
        this.setState({
          data:{...input},
          isBusy: false,
          success: "Saved",
        }, () => {
          if (!this.props.edit) {
            browserHistory.push({
              // pathname: `/tenant/${res.data.createOrUpdateTenent.tenent.arcimedes_row_id}`,
              pathname: `/users/${res.data.createOrUpdateUser.user.id}`,
            });
          }
        });

        window.scrollTo(0, 0);
      }
      else if(res && res.data && res.data.createOrUpdateUser && res.data.createOrUpdateUser.error && res.data.createOrUpdateUser.error.includes("already exists")){
        this.setState({
        isExists:true,
        typeDuplicate: res.data.createOrUpdateUser.error,
        viewMode:false
      })
      }
      else{
        this.setState({
          isBusy: null,
          error: res && res.createOrUpdateUser.error ? res.createOrUpdateUser.error : "Unspecified error",
      });
      }
    } catch (error) {
      console.error("Error in saveData:", error);
      this.setState({
        isBusy: false,
        error: error.message || "Unspecified error",
      });
    }
  }

  render() {
    const data = this.state.data;
    const { edit, isSuper } = this.props;

    return (
      <ApolloConsumer>
        {client => {
          if (!this.client) this.client = client;
          return (
            <CRUD
              tabsData={[
                {
                  name: "USER",
                  renderedComponent: (
                    <UserInfo
                      isExists={this.state.isExists}
                      typeDuplicate={this.state.typeDuplicate}
                      data={data}
                      handleChangeInput={this.handleChangeInput}
                      viewMode={this.state.viewMode}
                      deleted={data && data.deleted === 1}
                      handleChangeDropdown={this.handleChangeDropdown}
                      handleParentDropdownChange={this.handleChangeDropdown}
                    />
                  ),
                },
              ]}
              backLink={`${arc.path.base}userList`}
              edit={edit}
              state={this.state}
              setState={this.setState.bind(this)}
              handleSubmit={(e) => this.handleSubmit(client, e)}
              saveData={() => this.saveData(client)}
              type="user"
              backName="USER"
              title={
                data &&
                (data.first_name && data.last_name
                  ? `${data.first_name} ${data.last_name}`
                  : data.username)
              }
              isSuper={isSuper}
              filterData={this.state.filterData}
              currentIndex={this.state.currentIndex}
              updateURL={this.updateURL}
              // backToUrl={"tenants"}
              backToUrl={
                this.state.fromListUrl ? this.state.fromListUrl : "/users"
              }
            />
          );
        }}
      </ApolloConsumer>

    );
  }
}

